import { syncContenidoOrdenOnNode } from "./contenidoOrden";

/**
 * Removes temario testRefs matching a deleted test title across all tabs.
 * @param {Record<string, import("./temarioTree").TemarioNodo[]>} bloquesContenido
 * @param {string} titulo
 * @returns {Record<string, import("./temarioTree").TemarioNodo[]>}
 */
export function removeTestRefsByTituloFromContenido(bloquesContenido, titulo) {
  const trimmed = (titulo ?? "").trim();
  if (!trimmed || !bloquesContenido || typeof bloquesContenido !== "object") {
    return bloquesContenido;
  }

  const stripFromNodes = (nodes) => {
    if (!Array.isArray(nodes)) {
      return [];
    }
    return nodes.map((node) => {
      if (!node || typeof node !== "object") {
        return node;
      }
      const refs = Array.isArray(node.testRefs)
        ? node.testRefs.filter((ref) => ref && ref.titulo !== trimmed)
        : [];
      const hijos = stripFromNodes(node.hijos);
      const next = { ...node, testRefs: refs, hijos };
      syncContenidoOrdenOnNode(next);
      return next;
    });
  };

  /** @type {Record<string, import("./temarioTree").TemarioNodo[]>} */
  const out = {};
  for (const key of Object.keys(bloquesContenido)) {
    out[key] = stripFromNodes(bloquesContenido[key]);
  }
  return out;
}
